import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    data: false,
    error: "",
};

const runningStatusSlice = createSlice({
    name: "runningStatus",
    initialState,
    reducers: {
        setIsRunning(state, action) {
            state.data = action.payload;
        },
    },
});

export const { setIsRunning } = runningStatusSlice.actions;
export default runningStatusSlice.reducer;
